import { useQuery } from '@tanstack/react-query';
import { orpc } from '@/api/rpc/client';
import type {
  ProductVariantSearchResult,
  SearchProductVariantsInput,
} from '@erp/rpc';

export type { ProductVariantSearchResult };

export function useSearchProductVariants(
  params: SearchProductVariantsInput,
  enabled?: boolean,
) {
  const query = useQuery({
    ...orpc.inventoryManagement.productVariants.search.queryOptions({
      input: params,
    }),
    // `enabled` must sit at the top level of the query options (a nested
    // `query` key is ignored), and the contract trims + requires >=1 char --
    // gate on the trimmed value so an empty/whitespace box never fires a
    // request that would 422.
    enabled: enabled !== false && params.query.trim().length > 0,
  });

  return {
    ...query,
    data: query.data?.results ?? [],
  };
}
